import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const WeeklyJoiner = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [offerReport, setOfferReport] = useState([]);
  const [hrNameList, setHRNameList] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [filterFormData, setFilterData] = useState([
    { label: "HR Name", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  const columns = {
    FullName: { text: "Name", visible: true },
    MobileNo: { text: "Contact No", align: "center", visible: true },
    JobTitle: { text: "Job Title", visible: true },
    ActualJoiningDate: { text: "Date Of Joining", align: "center", visible: true },
  };


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Weekly Joinee"))
  }, [])


  const formDatas = [
    { name: "HR Name", type: "Select", options: [...hrNameList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchOfferReport = async () => {
    SetApiStatus(undefined)
     setOfferReport([]);
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/4?P_CreatedBy=&P_FromDate=${lastMonthDate}
        &P_ToDate=${todayDate}`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.weekly_joiny;
        setOfferReport(data);

        // Hr Name List
        const hrList = response?.data?.data?.hr_name?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchOfferReport();
  }, []);

  const handleGetData =async () => {
    SetApiStatus(undefined)
     setOfferReport([]);
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/4?P_CreatedBy=${filterFormData.find((o) => o.label === "HR Name")
          ? filterFormData.find((o) => o.label === "HR Name").value
          : ""}&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate}&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate}`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.weekly_joiny;
        setOfferReport(data);

        // Hr Name List
        const hrList = response?.data?.data?.hr_name?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleView = (id) => {
    navigate(`/candidate-history/view/${id.ID}`);
  }
const handleReset = ()=>{
  fetchOfferReport()
  setFilterData([
    { label: "HR Name", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ])
}
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={offerReport}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isFilterRequired={true}
              isSorting={true}
              isActionRequired={true}
              handleReset={handleReset}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              handleIcon1={handleView}
              filterFormData={filterFormData}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WeeklyJoiner;
